import { PromptCardQuery, TextQuery } from '~/services/api/conversations';

/**
 * Builds the discriminated-union `query` the new agent expects on /stream and
 * /commands/goto (AssistRequest.query: TextQuery | PromptCardQuery).
 *
 * @param {string} textMessage Flattened text (only used for the plain-text case —
 *   for a prompt card, the template + variables are what the backend renders from).
 * @param {{ versionContentId?: string, promptCardVariables?: import('~/services/api/conversations').PromptCardVariable[], promptCardTitle?: string }} promptCardsData
 *   Output of useConversations#processPromptCardData.
 * @returns {import('~/services/api/conversations').AssistQuery}
 */
export const buildAssistQuery = (textMessage, promptCardsData) =>
  promptCardsData.versionContentId
    ? new PromptCardQuery(promptCardsData.versionContentId, promptCardsData.promptCardVariables, promptCardsData.promptCardTitle)
    : new TextQuery(textMessage);
